import { ISchedulerContext } from '../../SchedulerContext';
import { IRutinSettingsContext } from '../../../../../../_Common/Components/RutinAvailabilityContext/RutinAvailabilityContext';
import { mergeDeepRight } from 'ramda';
import {
  formatDate,
  formatTime,
} from '../../../../../../../../Utils/dateUtils';
import {
  FormUpdateAssociatonType,
  getFormUpdateValue,
} from '../../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormValueUtils';
import {
  getAddResursUpdateArray,
  getUpdateForsamlingArray,
} from '../../../../../ObjektVyer/Aktivitet/AktivitetResursValjare';
import { IResourceInfo } from '../../../Utils/KalenderTypes';
import { MeQuery_me_bokningsgrupper } from '../../../Queries/MeQuery/_QueryTypes/MeQuery';

export interface INyAktivitetInitialValues {
  _typ?: string;
  FRANDATUM?: string;
  FRANTID?: string;
  TILLDATUM?: string;
  TILLTID?: string;
  _Associations?: any;
  WEBBOKAD?: string;
}

export const nyAktivitetInitialValues = (
  startDate: Date | undefined,
  endDate: Date | undefined,
  useTime: boolean,
  resName: string | number | undefined,
  schedulerContext: ISchedulerContext,
  rutinSettingsContext: IRutinSettingsContext
): INyAktivitetInitialValues => {
  const bokningsbaraResurser =
    schedulerContext.resources.filter(resource => resource.kanBoka) ?? [];
  const resource =
    bokningsbaraResurser.length === 1
      ? bokningsbaraResurser[0]
      : bokningsbaraResurser.find(resource => resource.resName === resName);
  const currentBookingGroupId = rutinSettingsContext.currentBookingGroup
    ? schedulerContext.bookingGroups?.me?.[0]?.bokningsgrupper?.find(
        item => item.namn === rutinSettingsContext.currentBookingGroup
      )?.id
    : undefined;
  const bookingGroup = currentBookingGroupId
    ? {
        id: currentBookingGroupId,
        BENAMNING: rutinSettingsContext?.currentBookingGroup,
      }
    : {
        id:
          schedulerContext.bookingGroups?.me?.[0].bokningsgrupper?.[0]?.id ??
          undefined,
        BENAMNING:
          schedulerContext.bookingGroups?.me?.[0].bokningsgrupper?.[0]?.namn ??
          undefined,
      };

  const platser = schedulerContext.resources.filter(
    resource => resource.resType === 'Plats'
  );

  let initialValues = {
    _Associations: {
      Bokningsgrupp_Ref: bookingGroup,
      Forsamling_Ref:
        platser.length === 1 && !schedulerContext.overView
          ? platser[0].platsForsamlingId
          : resource?.platsForsamlingId,
    },
    WEBBOKAD: 'Y',
    FRANDATUM: startDate ? formatDate(startDate) : undefined,
    TILLDATUM: endDate ? formatDate(endDate) : undefined,
    FRANTID: startDate && useTime ? formatTime(startDate) : undefined,
    TILLTID: endDate && useTime ? formatTime(endDate) : undefined,
  };
  if (resource) {
    const addResursUpdateArray = getAddResursUpdateArray(
      resource.resName,
      resource.BO_RESURS_ID ?? '',
      resource.resGQLId,
      resource.resType,
      resource.basTyp,
      initialValues.FRANDATUM ?? '',
      initialValues.TILLDATUM,
      useTime ? initialValues.FRANTID : undefined,
      useTime ? initialValues.TILLTID : undefined
    );
    const resursInitialValues = getFormUpdateValue(addResursUpdateArray, {});
    initialValues = mergeDeepRight(initialValues, resursInitialValues);
  } else if (platser.length === 1) {
    const addResursUpdateArray = getAddResursUpdateArray(
      platser[0].resName,
      platser[0].BO_RESURS_ID ?? '',
      platser[0].resGQLId,
      platser[0].resType,
      platser[0].basTyp,
      initialValues.FRANDATUM ?? '',
      initialValues.TILLDATUM,
      useTime ? initialValues.FRANTID : undefined,
      useTime ? initialValues.TILLTID : undefined
    );
    const resursInitialValues = getFormUpdateValue(addResursUpdateArray, {});
    initialValues = mergeDeepRight(initialValues, resursInitialValues);
  }

  return initialValues;
};

export const nyAktivitetInitialValues2 = (
  selectedStartDate: Date | undefined,
  selectedEndDate: Date | undefined,
  selectedResourceIds: string[] | undefined,
  resources: IResourceInfo[] | undefined,
  useTime: boolean,
  rutinSettingsContext: IRutinSettingsContext,
  bookingGroups?: MeQuery_me_bokningsgrupper[]
): INyAktivitetInitialValues => {
  const bokningsbaraResurser =
    selectedResourceIds && selectedResourceIds.length > 0
      ? resources?.filter(
          resource =>
            resource.kanBoka &&
            resource.BO_RESURS_ID &&
            selectedResourceIds.includes(resource.BO_RESURS_ID)
        ) ?? []
      : resources?.filter(
          resource => resource.kanBoka && resource.BO_RESURS_ID
        ) ?? [];
  const currentBookingGroupId = rutinSettingsContext.currentBookingGroup
    ? bookingGroups?.find(
        grp => grp.namn === rutinSettingsContext.currentBookingGroup
      )?.id
    : undefined;
  const bookingGroup = currentBookingGroupId
    ? {
        id: currentBookingGroupId,
        BENAMNING: rutinSettingsContext?.currentBookingGroup,
      }
    : {
        id: bookingGroups?.[0]?.id ?? undefined,
        BENAMNING: bookingGroups?.[0]?.namn ?? undefined,
      };

  let initialValues = {
    _Associations: {
      Bokningsgrupp_Ref: bookingGroup,
    },
    WEBBOKAD: 'Y',
    FRANDATUM: selectedStartDate ? formatDate(selectedStartDate) : undefined,
    TILLDATUM: selectedEndDate ? formatDate(selectedEndDate) : undefined,
    FRANTID:
      selectedStartDate && useTime ? formatTime(selectedStartDate) : undefined,
    TILLTID:
      selectedEndDate && useTime ? formatTime(selectedEndDate) : undefined,
  };
  if (selectedResourceIds && selectedResourceIds.length > 0) {
    let addResursUpdateArray: FormUpdateAssociatonType[][] = [];
    bokningsbaraResurser.forEach(resource => {
      if (selectedResourceIds.includes(resource.BO_RESURS_ID ?? '')) {
        addResursUpdateArray = [
          ...addResursUpdateArray,
          ...getAddResursUpdateArray(
            resource.resName,
            resource.BO_RESURS_ID ?? '',
            resource.resGQLId,
            resource.resType,
            resource.basTyp,
            initialValues.FRANDATUM ?? '',
            initialValues.TILLDATUM,
            useTime ? initialValues.FRANTID : undefined,
            useTime ? initialValues.TILLTID : undefined
          ),
        ];
      }
    });
    if (addResursUpdateArray) {
      const resursInitialValues = getFormUpdateValue(addResursUpdateArray, {});
      initialValues = mergeDeepRight(initialValues, resursInitialValues);
    }

    const forsamlingId = bokningsbaraResurser.find(
      resource =>
        selectedResourceIds.includes(resource.BO_RESURS_ID ?? '') &&
        resource.basTyp === 'Plats'
    )?.platsForsamlingId;
    if (forsamlingId) {
      const updateForsamlingArray = getUpdateForsamlingArray(forsamlingId);
      const forsamlingInitialValues = getFormUpdateValue(
        updateForsamlingArray,
        {}
      );
      initialValues = mergeDeepRight(initialValues, forsamlingInitialValues);
    }
  }

  return initialValues;
};
